import { Button } from '@travelnest/merlin.button';
import { IEventV2 } from '@travelnest/typewriter';
import { IPendingPostPayment, IPostPayment } from 'data/entities/post-payment';
import React, { useState } from 'react';
import { applyPending } from '../../../../data/entities/post-payment/index';
import { HistoricalPaymentComponent } from './HistoricalPaymentComponent';
import { NewExceptionalPayment } from './NewExceptionalPaymentContainer';

export interface IExceptionalPaymentsProps {
	event: IEventV2;
	pendingPayments: IPendingPostPayment[];
	deletePostPayments: (postPayments: IPostPayment[], eventId: string) => void;
}

const withinMinutes = (a: Date, b: Date, minutes: number): boolean => {
	const diff = Math.abs(a.getUTCMinutes() - b.getUTCMinutes());

	return diff <= minutes;
};

const groupPostPayments = (postPayments: IPostPayment[]) => {
	postPayments.sort((a, b) => {
		const aDate = new Date(a.created_at!);
		const bDate = new Date(b.created_at!);

		if (aDate.getTime() === bDate.getTime()) {
			return 0;
		}

		return aDate > bDate ? 1 : -1;
	});

	const output = [];
	let group: IPostPayment[] = [];
	for (const payment of postPayments) {
		const last = group.length > 0 ? group[0] : null;
		if (!last) {
			group.push(payment);
		} else if (last.reason === payment.reason && withinMinutes(new Date(last.created_at!), new Date(payment.created_at!), 3)) {
			group.push(payment);
		} else {
			if (group.length > 0) {
				output.push(group);
			}
			group = [payment];
		}
	}

	if (group.length > 0) {
		output.push(group);
	}

	return output.reverse();
};

export const ExceptionalPaymentsComponent: React.FunctionComponent<IExceptionalPaymentsProps> = (props) => {
	const [editFormExpanded, setEditFormExpanded] = useState(false);
	const toggleEditFormExpanded = () => setEditFormExpanded(!editFormExpanded);

	const booking = (props.event.booking || { post_payments: [] }) as any; // Temporary hack while Typewriter still exists
	const postPayments = booking.post_payments || [] as IPostPayment[];
	const allPostPayments = applyPending(props.pendingPayments, postPayments);
	const groupedPostPayments = groupPostPayments(allPostPayments);

	const deletePostPayments = (payments: IPostPayment[]) => props.deletePostPayments(payments, props.event.id);

	return <div>
		<div className="exceptional-payments__header">
			<div className="exceptional-payments__title">
				<h2>Exceptional Payments</h2>
			</div>
			<div className="exceptional-payments__title--button">
				<Button onClick={(event) => toggleEditFormExpanded()}>{editFormExpanded ? 'Close' : 'Add'}</Button>
			</div>
		</div>

		<NewExceptionalPayment
			event={props.event}
			expanded={editFormExpanded}
		/>

		<h3>Payment History</h3>

		<div className="exceptional-payments__row exceptional-payments__row--stacked">
			{groupedPostPayments.length > 0 ?
				groupedPostPayments.map((payments) =>
					<HistoricalPaymentComponent deletePostPayments={deletePostPayments} postPayments={payments} />) :
				<p>There have been no exceptional payments for this booking</p>
			}
		</div>
	</div>;
};
